import {useQuery} from '@apollo/client';
import {useEffect, useState} from 'react';
import {BCP_CHECK_USER_GROUPS} from '../graphql/queries/bcpCheckUserGroupQueries';
import {CheckUserGroupListResponse, CheckUserGroupType} from '../graphql/types/BcpCheckUserGroupTypes';

export interface BcpCheckUserGroupListQueryResult {
    data: CheckUserGroupType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
}

export const useBcpCheckUserGroupListQuery = (
    filters: {id?: number; groupName?: string},
    currentPage: number,
    pageSize: number,
    shouldFetch: boolean = true,
): BcpCheckUserGroupListQueryResult => {
    const [listData, setListData] = useState<CheckUserGroupType[]>([]);
    const [total, setTotal] = useState(0);

    const {data, loading, refetch} = useQuery<CheckUserGroupListResponse>(BCP_CHECK_USER_GROUPS, {
        variables: {
            id: filters.id ?? undefined,
            groupName: filters.groupName || undefined,
            pageRequest: {page: currentPage, size: pageSize, sortBy: 'id', sortDirection: 'DESC'},
        },
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        const content = data?.bcpCheckUserGroups?.content;
        if (content) {
            setListData(content);
        }
        const rawTotal = data?.bcpCheckUserGroups?.pageInfo?.totalElements;
        if (rawTotal !== undefined && rawTotal !== null) {
            const n = Number(rawTotal);
            if (Number.isFinite(n)) {
                setTotal(Math.max(0, Math.trunc(n)));
            }
        }
    }, [data]);

    return {data: listData, loading, refetch, totalElements: total};
};
